import { type IGetActionsData, formatDate } from "@api";
import { formatTimeFromDate } from "@candidate/components/utils/formatTools";
import { Stack, Typography } from "@mui/material";
import { useI18nContext } from "@root/utils/organisation";
import type { Dispatch, SetStateAction } from "react";
import { classes } from "../styles";
import type { IActionPopoverState } from "../types";

export interface IChallengeTitleProps {
  action: IGetActionsData;
  title: string;
  setActionPopoverState?: Dispatch<SetStateAction<IActionPopoverState>>;
}

export const ChallengeTitle = ({ action, title, setActionPopoverState }: IChallengeTitleProps) => {
  const { timeZone } = useI18nContext();
  const startTime = action.executionPeriod?.startDate
    ? formatTimeFromDate(action.executionPeriod.startDate, undefined, timeZone)
    : action.executionDate
      ? formatTimeFromDate(action.executionDate, undefined, timeZone)
      : action.deadlineDate
        ? formatTimeFromDate(action.deadlineDate, undefined, timeZone)
        : "";

  const startDate = action.executionPeriod
    ? action.executionPeriod.startDate
      ? action.executionPeriod.startDate
      : action.executionPeriod.endDate
    : action.executionDate
      ? action.executionDate
      : action.deadlineDate;

  const endDate = action.executionPeriod
    ? action.executionPeriod.endDate
      ? action.executionPeriod.endDate
      : action.executionPeriod.startDate
    : action.endDate;

  return (
    <Stack sx={{ minWidth: 0 }}>
      <Typography
        className={classes.title}
        variant="subtitle1"
        onClick={
          setActionPopoverState
            ? (evt) => {
                setActionPopoverState({
                  anchorEl: evt.currentTarget,
                  actions: [action],
                });
              }
            : undefined
        }
        sx={setActionPopoverState ? { cursor: "pointer" } : undefined}
      >
        <span className={classes.capitalize}>
          <Typography component="span" variant="subtitle1">
            {startDate
              ? endDate
                ? startDate.getDate() === endDate.getDate()
                  ? `Le ${formatDate(startDate, timeZone)}${startTime ? ` à ${startTime} - ` : " - "}`
                  : `Du ${formatDate(startDate, timeZone)} au ${formatDate(endDate, timeZone)} - `
                : `Le ${formatDate(startDate, timeZone)}${startTime ? ` à ${startTime} - ` : " - "}`
              : ""}
          </Typography>
          <Typography component="span" variant="subtitle1SemiBold" color="primary">
            {title}
          </Typography>
        </span>
      </Typography>
    </Stack>
  );
};
